export default {"src":"/_next/static/media/logo-bloomberg-vector-white.20ddba59.svg","height":31,"width":151,"blurWidth":0,"blurHeight":0};